import React from 'react';
import System from '../../basic/System';
import ViewUtil from '../../ViewUtil';
import Setting from './Setting';
import './settingsTab.css';

const SettingsTab = () => {
  const settingOptions = [
    {
      title: 'Profile',
      description: 'Change your profile image and password',
      img: 'images/profileSetting.svg'
    },
    {
      title: 'Application',
      description: 'Change general setting of application',
      img: 'images/accountSetting.svg'
    },
    // {
    //     title:'Collections',
    //     description: 'Change collection settings',
    //     img: 'images/collectionSetting.svg'
    // },
    // {
    //   title: 'Notifications',
    //   description: 'Change notifications settings',
    //   img: 'images/notificationSetting.svg'
    // }
  ];

  if (System.isDesktop()) {
    settingOptions.push({
      title: 'Evolphin Media Store Drives',
      description: 'Manage Evolphin Media Store Drives',
      img: 'images/cloud-database.svg'
    });
  }

  if (window.ARGS.currentSetting) {
    return <Setting currentSetting={window.ARGS.currentSetting} />;
  } else {
    return (
      <div name="SettingsTab">
        <div className="tab-title">Settings</div>
        <div className="settings">
          {settingOptions.map((settings) => {
            return (
              <div key={settings.title} className="setting" onClick={() => ViewUtil.switchToSetting(settings.title)}>
                <div className="img">
                  <img src={settings.img} style={{ height: '50px', width: '50px' }} />
                </div>
                <div className="setting-title">{settings.title}</div>
                <div className="setting-description">{settings.description}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
};
export default SettingsTab;
